module.exports = __webpack_public_path__ + "img/card_ip_stipulation78.48eb3f3a.svg";